import scrollDir from "scrolldir";
import { invalidInputFocus } from "../components/form/js/invalidInputFocus";
import { AccordionItems } from "../components/accordion-item";
import lazySizes from "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "lazysizes/plugins/attrchange/ls.attrchange";
import "./js/button-loader";
import "./js/module-planner-index";

document.addEventListener("DOMContentLoaded", () => {
  $(document).foundation();

  new invalidInputFocus();
  new AccordionItems();
  scrollDir();

  // This doesn't work anymore. We need to figure out why. For the time being we've replaced all class="lazy" to class"lazyload"
  // lazySizes.cfg.lazyClass = 'lazy';
  lazySizes.init();
});
